<script lang="ts">
  type Props =
    & {
      type?: "accent" | "normal" | "error" | "warning";
      outset?: boolean;
      shadow?: boolean;
      nowrap?: boolean;
    }
    & ({
      text?: undefined;
      children: () => any;
    } | {
      text: string;
      children?: undefined;
    });
  const {
    nowrap = false,
    shadow = false,
    type = "normal",
    outset = false,
    children,
    text,
  }: Props = $props();
</script>

<div
  class="text-opacity-50 text-grey-90 rounded-[5px] text-xs py-1 px-2 inline-block"
  class:whitespace-nowrap={nowrap}
  class:shadow
  class:outset
  class:bg-greenGrey-10={type === "normal"}
  class:bg-error-fg={type === "error"}
  class:bg-orange-30={type === "warning"}
  class:bg-yellow-50={type === "accent"}
  class:font-bold={type === "accent"}
>
  {#if text}
    {text}
  {/if}

  {#if children}
    {@render children()}
  {/if}
</div>
